import InsightsDataFetchSource from '../store/schema/InsightsDataFetchSource';
import SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';

export default function getScenarioEndpoint(
    dataFetchSource: InsightsDataFetchSource
): SubstrateSearchScenario {
    switch (dataFetchSource) {
        // Meeting Insights endpoint
        case InsightsDataFetchSource.ReadingPane:
        case InsightsDataFetchSource.Deeplink:
        case InsightsDataFetchSource.PrefetchOnCalendarSelected:
        case InsightsDataFetchSource.TabbedDetailsForm:
            return SubstrateSearchScenario.MeetingPrep;

        case InsightsDataFetchSource.ItemPeek:
            return SubstrateSearchScenario.MeetingPrepPeek;

        case InsightsDataFetchSource.Reminder:
            return SubstrateSearchScenario.MeetingPrepReminder;
        case InsightsDataFetchSource.CalendarCard:
            return SubstrateSearchScenario.MeetingPrepMailCalendarCard;

        // Up-next agenda view endpoint
        case InsightsDataFetchSource.PrefetchOnAgendaView:
        case InsightsDataFetchSource.AgendaView:
        case InsightsDataFetchSource.TimePanelEventDetails:
        case InsightsDataFetchSource.UpNext:
        default:
            return SubstrateSearchScenario.MeetingPrepAgenda;
    }
}
